import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/app/[locale]/product-library/error.tsx");
